// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1UOu8","col":"CardReaderDesc_col__2ybs6","label":"CardReaderDesc_label__3Z0pi"};